module.exports = __webpack_public_path__ + "static/img/flipped-aurora.a4221a78.png";